<template>
  <div class="main_body">
  	<div class="layui-layout layui-layout-admin">
  			<!-- 左侧导航 -->
  			<div :style="{left:$store.state.side_left}" id="left_nav" class="layui-side">
  				<el-menu
  				 default-active="0"
  				 :default-active="$route.path"
  				 :collapse="collapsed"
  				 unique-opened
  				 router
  				 collapse-transition
  				 class="el-menu-vertical-demo"
  				 background-color="#334157"
  				 text-color="#fff"
  				 active-text-color="#409EFF"
  				 >
  				  <el-submenu :index='item.title' :key='index' v-for="(item,index) in data_str">
  				    <template slot='title'>
  				      <icon-svg :iconClass="item.icon"/>
  				      <span>{{item.title}}</span>
  				    </template>
  				    <el-menu-item :index='item1.href' :key='index' v-for="(item1,index) in item.children">
  				      <icon-svg :iconClass="item1.icon"/>
  				      <span>{{item1.title}}</span>
  				    </el-menu-item>
  				  </el-submenu>
  				</el-menu>
  			</div>
  			<!-- 右侧内容 -->
  			<div class="layui-body" :style="{left:$store.state.body_left}">
  			  <!-- 顶部 -->
  			  <div class="layui-header header">
  			  	<div class="mag0" :style="{left:$store.state.body_left}">
  			  		<a href="javascript:;" class="logo" style="overflow: hidden;">供应链协同管理平台</a>
  			  		<!-- 显示/隐藏菜单 -->
  			  		<span title="显隐菜单栏" class="seraph hideMenu icon-caidan" @click="hideMenu()"></span>
  			      <!-- 顶部右侧菜单 -->
  			  	  <ul class="layui-nav top_menu">
  			  			<!-- <li class="layui-nav-item" pc>
  			  				<a href="javascript:;" class="clearCache"><i class="layui-icon" data-icon="&#xe640;">&#xe640;</i><cite>清除缓存</cite><span class="layui-badge-dot"></span></a>
  			  			</li>
  			  			<li class="layui-nav-item lockcms" pc>
  			  				<a href="javascript:;"><i class="seraph icon-lock"></i><cite>锁屏</cite></a>
  			  			</li> -->
  			  			<li class="layui-nav-item" id="userInfo">
  			          <el-dropdown>
  			            <a href="javascript:;"><img src="../assets/face.jpg" class="layui-nav-img userAvatar" width="35" height="35"><cite class="adminName">{{user_name}}</cite></a>
  			            <el-dropdown-menu slot="dropdown">
  			              <el-dropdown-item @click.native="$router.push({path:'/user/personal_data'})">
  			                <span><i class="seraph icon-ziliao" data-icon="icon-ziliao"></i>个人资料</span>
  			              </el-dropdown-item>
  			              <el-dropdown-item @click.native="$router.push({path:'/user/change_password'})">
  			                <span><i class="seraph icon-xiugai" data-icon="icon-xiugai"></i>修改密码</span>
  			              </el-dropdown-item>
  			              <!-- <el-dropdown-item>
  			                <a href="javascript:;" class="showNotice"><i class="layui-icon">&#xe645;</i><cite>系统公告</cite><span class="layui-badge-dot"></span></a>
  			              </el-dropdown-item>
  			              <el-dropdown-item>
  			                <a href="javascript:;" class="functionSetting"><i class="layui-icon">&#xe620;</i><cite>功能设定</cite><span class="layui-badge-dot"></span></a>
  			              </el-dropdown-item>
  			              <el-dropdown-item>
  			                <a href="javascript:;" class="changeSkin"><i class="layui-icon">&#xe61b;</i><cite>更换皮肤</cite></a>
  			              </el-dropdown-item> -->
  			              <el-dropdown-item @click.native="signOut()">
  			                <span class="signOut"><i class="seraph icon-tuichu"></i>退出</span>
  			              </el-dropdown-item>
  			            </el-dropdown-menu>
  			          </el-dropdown>
  			  			</li>
  			  		</ul>
  			  	</div>
  			  </div>
  			  <el-main>
  			    <!-- 内容主体 -->
  			    <div class="app-wrap">
  			      <el-tabs
  			      v-model="$store.state.activeIndex"
  			      type="border-card"
  			      closable
  			      v-if="$store.state.openTab.length"
  			      @tab-click='tabClick'
  			      @tab-remove='tabRemove'
  			      >
  			        <!-- 获取vuex中的openTab数组数据，循环展示 -->
  			        <el-tab-pane
  			        :key="item.name+index"
  			        v-for="(item,index) in $store.state.openTab"
  			        :label="item.name"
  			        :name="item.route"
  			        >
  			          <div class="content-wrap" style="height: 100%;">
  			            <keep-alive>
  			              <!-- 展示路由 -->
  			              <router-view v-if="item.route==$route.path"/>
  			            </keep-alive>
  			          </div>
  			        </el-tab-pane>
  			      </el-tabs>
  			    </div>
  			  </el-main>
  			  <div class="layui-footer footer" :style="{left:$store.state.body_left}">
  			    <p>
  			      <a href="https://beian.miit.gov.cn" target="_blank">copyright @2022 沪ICP备09093429号 上海润达医疗科技股份有限公司</a>
  			    </p>
  			  </div>
  			</div>
  		</div>

  		<!-- 移动导航 -->
  		<div style="display: none;" @click="open_side()" class="site-tree-mobile"><i class="layui-icon">&#xe602;</i></div>
  		<div class="site-mobile-shade"></div>
  </div>

</template>

<script>
	export default {
    name:'index',
    data(){
			return{
        //更新弹框是否已展示
        uploadNotificationShow:false,
        // side_left:'',
        // body_left:'',
        // side_flag:false,
        dataStr:JSON.parse(localStorage.getItem(localStorage.getItem('userName')+"menu")),
        data_str:[
          {
            children:[
              {
                children:null,
                href:'/warn_index',
                icon:'icon-renwumianban2',
                spread:false,
                title:'任务面板'
              }
            ],
            href:'',
            icon:'icon-shouye',
            spread:false,
            title:'首页'
          }
        ],
        user_name:localStorage.getItem('nickName')+' — '+localStorage.getItem('dataWarehouse'),
        form:'',
        collapsed:false
			}
		},
    beforeCreate() {
      document.querySelector('body').setAttribute('style','zoom: 0.8;')
    },
		created() {
      let that=this
      that.publicAjax.axios_set()
      //清除掉存储的layId
      localStorage.removeItem('layIdStr')
      console.log(this.dataStr)
      if(this.dataStr==null){
        this.$router.push({path:'/'})
      }else{
        this.data_str=this.data_str.concat(this.dataStr)
      }
    //   layui.use(['form','element', 'layer', 'jquery'],function(){
    //     let form=layui.form
				// that.element=layui.element

    //     //登录是否过期校验
    //     that.$axios({
    //       method:'post',
    //       url:that.publicAjax.extra_path+'/admin/user/checkLogin'
    //     }).then(data=>{
    //       if(data.data.success==true){
    //         that.dataStr=data.data.data.menu
    //         that.data_str=that.data_str.concat(that.dataStr)
    //       }else{
    //         that.$message.error(data.data.message)
    //         setTimeout(function(){
    //           that.$router.push({path:'/login'})
    //         },1000)
    //       }
    //     })
    //   })
    },
		mounted() {
      if(location.href.indexOf('#reloaded')==-1){
        location.href=location.href+'#reloaded'
        location.reload()
      }
      //刷新时以当前路由作为tab加入tabs
      //当前路由不是首页时，添加首页以及另一页到store，并设置激活状态
      //当当前路由是首页时，添加首页到store，并设置激活状态
      if(this.$route.path!=='/'&&this.$route.path!=='/warn_index'){
        this.$store.commit('add_tabs',{
          route:'/warn_index',
          name:'任务面板'
        })
        //通过路由的判断，来加入标签页的名称
        //系统设置
        if(this.$route.path=='/set/menu'){
          this.$store.commit('add_tabs',{
            route:this.$route.path,
            name:'权限管理'
          })
        }
        if(this.$route.path=='/set/role'){
          this.$store.commit('add_tabs',{
            route:this.$route.path,
            name:'角色管理'
          })
        }
        if(this.$route.path=='/set/dict_info'){
          this.$store.commit('add_tabs',{
            route:this.$route.path,
            name:'字典信息管理'
          })
        }
        if(this.$route.path=='/set/dict_type'){
          this.$store.commit('add_tabs',{
            route:this.$route.path,
            name:'字典类型管理'
          })
        }
        if(this.$route.path=='/set/buffer_manage'){
          this.$store.commit('add_tabs',{
            route:this.$route.path,
            name:'日志缓存管理'
          })
        }
        //用户管理
        if(this.$route.path=='/user/query'){
          this.$store.commit('add_tabs',{
            route:this.$route.path,
            name:'用户管理'
          })
        }
        if(this.$route.path=='/user/personal_data'){
          this.$store.commit('add_tabs',{
            route:this.$route.path,
            name:'个人资料'
          })
        }
        if(this.$route.path=='/user/change_password'){
          this.$store.commit('add_tabs',{
            route:this.$route.path,
            name:'修改密码'
          })
        }
        //冷链事务
        if(this.$route.path=='/cold/manage'){
          this.$store.commit('add_tabs',{
            route:this.$route.path,
            name:'冷链管理'
          })
        }
        if(this.$route.path=='/cold/batch'){
          this.$store.commit('add_tabs',{
            route:this.$route.path,
            name:'批次管理'
          })
        }
        if(this.$route.path=='/cold/back'){
          this.$store.commit('add_tabs',{
            route:this.$route.path,
            name:'设备签回'
          })
        }
        if(this.$route.path=='/cold/device_view'){
          this.$store.commit('add_tabs',{
            route:this.$route.path,
            name:'设备总览'
          })
        }
        if(this.$route.path=='/cold/truck_detail'){
          this.$store.commit('add_tabs',{
            route:this.$route.path,
            name:'冷链车监控详情'
          })
        }
        if(this.$route.path=='/cold/temp_detail'){
          this.$store.commit('add_tabs',{
            route:this.$route.path,
            name:'温度记录仪详情'
          })
        }
        if(this.$route.path=='/cold/cold_storage_detail'){
          this.$store.commit('add_tabs',{
            route:this.$route.path,
            name:'冷库监控详情'
          })
        }
        if(this.$route.path=='/cold/alarm_manage'){
          this.$store.commit('add_tabs',{
            route:this.$route.path,
            name:'报警管理'
          })
        }
        if(this.$route.path=='/cold/cold_storage_data'){
          this.$store.commit('add_tabs',{
            route:this.$route.path,
            name:'冷库数据查询'
          })
        }
        if(this.$route.path=='/cold/warehouse_manage'){
          this.$store.commit('add_tabs',{
            route:this.$route.path,
            name:'库房管理'
          })
        }
        //工单管理
        if(this.$route.path=='/work_order/my'){
          this.$store.commit('add_tabs',{
            route:this.$route.path,
            name:'我的工单'
          })
        }
        if(this.$route.path=='/work_order/manage_list'){
          this.$store.commit('add_tabs',{
            route:this.$route.path,
            name:'工单管理列表'
          })
        }
        //基础档案
        if(this.$route.path=='/record/client'){
          this.$store.commit('add_tabs',{
            route:this.$route.path,
            name:'客户档案'
          })
        }
        if(this.$route.path=='/record/product'){
          this.$store.commit('add_tabs',{
            route:this.$route.path,
            name:'产品档案'
          })
        }
        if(this.$route.path=='/record/device_list'){
          this.$store.commit('add_tabs',{
            route:this.$route.path,
            name:'设备管理'
          })
        }
        if(this.$route.path=='/record/storage'){
          this.$store.commit('add_tabs',{
            route:this.$route.path,
            name:'仓库管理'
          })
        }
        if(this.$route.path=='/record/check_plan'){
          this.$store.commit('add_tabs',{
            route:this.$route.path,
            name:'查看平面图'
          })
        }
        //订单管理
        if(this.$route.path=='/order/stock_in'){
          this.$store.commit('add_tabs',{
            route:this.$route.path,
            name:'入库单管理'
          })
        }
        if(this.$route.path=='/order/stock_out'){
          this.$store.commit('add_tabs',{
            route:this.$route.path,
            name:'出库单管理'
          })
        }
        //库存管理
        if(this.$route.path=='/store/query'){
          this.$store.commit('add_tabs',{
            route:this.$route.path,
            name:'库存查询'
          })
        }
        if(this.$route.path=='/store/business'){
          this.$store.commit('add_tabs',{
            route:this.$route.path,
            name:'库存事务'
          })
        }
        //自定义报表
        if(this.$route.path=='/report/manage'){
          this.$store.commit('add_tabs',{
            route:this.$route.path,
            name:'报表管理'
          })
        }
        if(this.$route.path=='/report/query'){
          this.$store.commit('add_tabs',{
            route:this.$route.path,
            name:'查询报表'
          })
        }
        //费用管理
        if(this.$route.path=='/expense/message'){
          this.$store.commit('add_tabs',{
            route:this.$route.path,
            name:'耗材费用基础信息'
          })
        }
        if(this.$route.path=='/expense/province'){
          this.$store.commit('add_tabs',{
            route:this.$route.path,
            name:'外地费用'
          })
        }
        if(this.$route.path=='/expense/indoor'){
          this.$store.commit('add_tabs',{
            route:this.$route.path,
            name:'本地费用'
          })
        }
        if(this.$route.path=='/expense/manage'){
          this.$store.commit('add_tabs',{
            route:this.$route.path,
            name:'耗材费用管理'
          })
        }
        this.$store.commit('set_active_index',this.$route.path)
      }else{
        this.$store.commit('add_tabs',{
          route:'/warn_index',
          name:'任务面板'
        })
        this.$store.commit('set_active_index','/warn_index')
        this.$router.push('/warn_index')
      }
      //版本更新
      setInterval(()=>{
        this.getHash()
      },180000)
		},
    watch:{
      '$route'(to,from){
        //更新权限
        this.change_permission()
        //判断路由是否已经打开
        //已经打开的，将其置为active
        //未打开的，将其放入队列中
        let flag=false
        for(let item of this.$store.state.openTab){
          if(item.route===to.path){
            this.$store.commit('set_active_index',to.path)
            flag=true
            break;
          }
        }
        if(!flag){
          //通过路由的判断，来加入标签的名称
          //系统设置
          if(to.path=='/set/menu'){
            this.$store.commit('add_tabs',{
              route:to.path,
              name:'权限管理'
            })
          }
          if(to.path=='/set/role'){
            this.$store.commit('add_tabs',{
              route:to.path,
              name:'角色管理'
            })
          }
          if(to.path=='/set/dict_info'){
            this.$store.commit('add_tabs',{
              route:to.path,
              name:'字典信息管理'
            })
          }
          if(to.path=='/set/dict_type'){
            this.$store.commit('add_tabs',{
              route:to.path,
              name:'字典类型管理'
            })
          }
          if(to.path=='/set/buffer_manage'){
            this.$store.commit('add_tabs',{
              route:to.path,
              name:'日志缓存管理'
            })
          }
          //用户管理
          if(to.path=='/user/query'){
            this.$store.commit('add_tabs',{
              route:to.path,
              name:'用户管理'
            })
          }
          if(to.path=='/user/personal_data'){
            this.$store.commit('add_tabs',{
              route:to.path,
              name:'个人资料'
            })
          }
          if(to.path=='/user/change_password'){
            this.$store.commit('add_tabs',{
              route:to.path,
              name:'修改密码'
            })
          }
          //冷链事务
          if(to.path=='/cold/manage'){
            this.$store.commit('add_tabs',{
              route:to.path,
              name:'冷链管理'
            })
          }
          if(to.path=='/cold/batch'){
            this.$store.commit('add_tabs',{
              route:to.path,
              name:'批次管理'
            })
          }
          if(to.path=='/cold/back'){
            this.$store.commit('add_tabs',{
              route:to.path,
              name:'设备签回'
            })
          }
          if(to.path=='/cold/device_view'){
            this.$store.commit('add_tabs',{
              route:to.path,
              name:'设备总览'
            })
          }
          if(to.path=='/cold/truck_detail'){
            this.$store.commit('add_tabs',{
              route:to.path,
              name:'冷链车监控详情'
            })
          }
          if(to.path=='/cold/temp_detail'){
            this.$store.commit('add_tabs',{
              route:to.path,
              name:'温度记录仪详情'
            })
          }
          if(to.path=='/cold/cold_storage_detail'){
            this.$store.commit('add_tabs',{
              route:to.path,
              name:'冷库监控详情'
            })
          }
          if(to.path=='/cold/alarm_manage'){
            this.$store.commit('add_tabs',{
              route:to.path,
              name:'报警管理'
            })
          }
          if(to.path=='/cold/cold_storage_data'){
            this.$store.commit('add_tabs',{
              route:to.path,
              name:'冷库数据查询'
            })
          }
          if(to.path=='/cold/warehouse_manage'){
            this.$store.commit('add_tabs',{
              route:to.path,
              name:'库房管理'
            })
          }
          //工单管理
          if(to.path=='/work_order/my'){
            this.$store.commit('add_tabs',{
              route:to.path,
              name:'我的工单'
            })
          }
          if(to.path=='/work_order/manage_list'){
            this.$store.commit('add_tabs',{
              route:to.path,
              name:'工单管理列表'
            })
          }
          //基础档案
          if(to.path=='/record/client'){
            this.$store.commit('add_tabs',{
              route:to.path,
              name:'客户档案'
            })
          }
          if(to.path=='/record/product'){
            this.$store.commit('add_tabs',{
              route:to.path,
              name:'产品档案'
            })
          }
          if(to.path=='/record/device_list'){
            this.$store.commit('add_tabs',{
              route:to.path,
              name:'设备管理'
            })
          }
          if(to.path=='/record/storage'){
            this.$store.commit('add_tabs',{
              route:to.path,
              name:'仓库管理'
            })
          }
          if(to.path=='/record/check_plan'){
            this.$store.commit('add_tabs',{
              route:to.path,
              name:'查看平面图'
            })
          }
          //订单管理
          if(to.path=='/order/stock_in'){
            this.$store.commit('add_tabs',{
              route:to.path,
              name:'入库单管理'
            })
          }
          if(to.path=='/order/stock_out'){
            this.$store.commit('add_tabs',{
              route:to.path,
              name:'出库单管理'
            })
          }
          //库存管理
          if(to.path=='/store/query'){
            this.$store.commit('add_tabs',{
              route:to.path,
              name:'库存查询'
            })
          }
          if(to.path=='/store/business'){
            this.$store.commit('add_tabs',{
              route:to.path,
              name:'库存事务'
            })
          }
          //自定义报表
          if(to.path=='/report/manage'){
            this.$store.commit('add_tabs',{
              route:to.path,
              name:'报表管理'
            })
          }
          if(to.path=='/report/query'){
            this.$store.commit('add_tabs',{
              route:to.path,
              name:'查询报表'
            })
          }
          //费用管理
          if(to.path=='/expense/message'){
            this.$store.commit('add_tabs',{
              route:to.path,
              name:'耗材费用基础信息'
            })
          }
          if(to.path=='/expense/province'){
            this.$store.commit('add_tabs',{
              route:to.path,
              name:'外地费用'
            })
          }
          if(to.path=='/expense/indoor'){
            this.$store.commit('add_tabs',{
              route:to.path,
              name:'本地费用'
            })
          }
          if(to.path=='/expense/manage'){
            this.$store.commit('add_tabs',{
              route:to.path,
              name:'耗材费用管理'
            })
          }
          this.$store.commit('set_active_index',to.path)
        }
      }
    },
    updated() {

    },
		methods:{
      //版本更新
      close(){
        this.uploadNotificationShow=false
        console.log(this.uploadNotificationShow)
      },
      onRefresh(new_hash){
        this.close()
        //更新localStorage版本号信息
        localStorage.setItem('Version',new_hash)
      },
      openNotification(new_hash){
        this.uploadNotificationShow=true
        const h=this.$createElement
        let that=this
        this.$message.success({
          message: h('span', null, [
            h('span', null, '当前版本已更新，请刷新后使用 '),
            h('a', {
                on: {
                  click: function () {
                    that.onRefresh(new_hash)
                    //刷新页面
                    window.location.reload(true)
                  }
                },
                style:'cursor:pointer;color:rgb(22, 96, 199);border-bottom:1px solid;padding: 2px 0'
              }, '刷新页面')
          ]),

          duration: 0,
          showClose: true,
          onClose:()=>{
            that.uploadNotificationShow=false
          },
          customClass:'refresh'
        });
      },
      //获取hash
      getHash(){
        //如果提示弹框没有展示
        if(!this.uploadNotificationShow){
          this.$axios.get(`${window.location.origin}/index.html?time=${new Date().getTime()}`).then(res=>{
            let new_hash = res.data && res.data.match(/\/static\/js\/app.(.*).js/)
            new_hash = new_hash ? new_hash[1] : null
            //查看本地版本
            let old_hash=localStorage.getItem('Version')
            if(!old_hash){
              // 如果本地没有，则存储版本信息
              this.onRefresh(new_hash)
            }else if(new_hash && new_hash != old_hash){
              // 本地已有版本信息，但是和新版不同：版本更新，弹出提示
              this.openNotification(new_hash)
            }
          })
        }
      },
      //显影侧边栏
      open_side(){

      },
			//退出登录
			signOut(){
				// localStorage.removeItem('nickName')
				// localStorage.removeItem('token')
				// localStorage.removeItem('userName')
				// localStorage.removeItem('permission')
				// localStorage.removeItem('menu')
        let that=this
        localStorage.clear()
        sessionStorage.clear()
				that.$notify({
				  message:'正在退出...',
				  duration:2000,
				  onClose:function(){
				    that.$router.push({path:'/'})
				  }
				})
			},
			//隐藏左侧导航
      hideMenu(){
        this.$store.state.side_flag=!this.$store.state.side_flag
        if(this.$store.state.side_flag==true){
          this.$store.state.side_left=-260+'px'
          this.$store.state.body_left=40+'px'
        }else{
          this.$store.state.side_left=''
          this.$store.state.body_left=''
        }
      },
      //tab标签点击时，切换相应的路由
      tabClick(tab){
        this.$router.push({path:this.$store.state.activeIndex})
      },
      //移除tab标签
      tabRemove(targetName){
        //首页不删
        if(targetName=='/warn_index'){
          return
        }
        this.$store.commit('delete_tabs',targetName)
        if(this.$store.state.activeIndex===targetName){
          //设置删除后，重新激活的路径
          if(this.$store.state.openTab&&this.$store.state.openTab.length>=1){
            //设置路由展示，为索引前一个路由
            this.$store.commit('set_active_index',this.$store.state.openTab[this.$store.state.openTab.length-1].route)
            //跳转路由
            this.$router.push({path:this.$store.state.activeIndex})
          }else{
            //否则跳转到首页
            this.$router.push({path:'/warn_index'})
          }
        }
      },
      //更新权限
      change_permission(){
        let that=this
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/admin/user/permission',
          headers:{
            "scctoken": localStorage.getItem(localStorage.getItem('userName')+'token'),
            "content-type":"application/x-www-form-urlencoded"
          }
        }).then(data=>{
          if(data.data.success==true){
            localStorage.setItem(localStorage.getItem('userName')+'permission',JSON.stringify(data.data.data))
          }else{
            // Message.error(data.data.message)
            // setTimeout(function(){
            //   Router.push({path:'/'})
            // },1000)
          }
        })
      }
		}
	}
</script>

<style scoped="scoped">
	@import "../../static/layui-icon-extend/iconfont.css";
	@import "../../static/icon.css";
	@import "../../static/index.css";
  .layui-layout{
    display: flex;
    justify-content: space-around;
  }
  .header{
    background-image: linear-gradient(to left,#393D49,#334157) !important;
    overflow: hidden;
  }
  .header .mag0{
    left: 300px;
    right: 0;
    top: 0;
    position: fixed;
    background-image: linear-gradient(to left,#393D49,#334157);
  }
  #left_nav{
    background-color: #334157;
    overflow-y: scroll;
  }
  .el-menu{
    border-right: none;
    overflow-x: hidden;
    padding: 20px;
  }
  .el-submenu__title i{
    color: #FFFFFF;
  }
  .footer{
    text-align: center;
    line-height: 44px;
  }
  @media screen and (max-width:720px) {
    .header .logo{
      display: none;
    }
  }
</style>
<style>
  .el-select-dropdown__wrap{
    max-height: 150px;
  }
  /* @media screen and (max-width:720px) {
    .el-picker-panel{
      left: 0 !important;
    }
    .el-picker-panel{
      width: 100%;
      overflow-x: scroll;
    }
  } */
  .operate{
    margin-bottom: 2px;
    cursor: pointer;
  }
  /* 设置滚动条的样式 */
  ::-webkit-scrollbar{
    width:12px;
    height: 12px;
  }
  /* 滚动槽 */
  ::-webkit-scrollbar-track{
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 10px;
  }
  /* 滚动条滑块 */
  ::-webkit-scrollbar-thumb{
    border-radius: 10px;
    background: rgba(0,0,0,0.1);
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5);
  }
  ::-webkit-scrollbar-thumb:window-inactive{
    background: rgba(64,158,255,0.2);
  }
  ::-webkit-scrollbar-thumb:hover{
    background: rgba(64,158,255,0.2);
  }
</style>



// WEBPACK FOOTER //
// src/components/index.vue